import React from 'react';
import { motion } from 'framer-motion';
import { MdGavel } from 'react-icons/md';

const TermsOfService = () => {
  return (
    <div className="relative bg-black min-h-screen text-white pt-32 pb-20 selection:bg-[#D4AF37]/30 selection:text-[#D4AF37] font-sans">
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none">
          <div className="absolute top-0 right-[10%] w-[500px] h-[500px] bg-[#D4AF37]/5 blur-[120px] rounded-full" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="space-y-12"
        >
          <div className="text-center space-y-4">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-white/5 border border-[#D4AF37]/30 text-[#D4AF37] mb-4">
              <MdGavel size={32} />
            </div>
            <h1 className="text-4xl md:text-5xl font-black tracking-tight">Terms of Service</h1>
            <p className="text-zinc-400 font-semibold max-w-2xl mx-auto">
              Effective Date: {new Date().toLocaleDateString()} <br/>
              By using VisionCarePlus, you agree to these Terms of Service. Please read them carefully.
            </p>
          </div>

          <div className="space-y-8 bg-zinc-900/50 border border-white/5 p-8 md:p-12 rounded-3xl backdrop-blur-sm">
            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-[#D4AF37]">1. Medical Disclaimer</h2>
              <div className="p-4 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-xl">
                 <p className="text-[#D4AF37] font-medium leading-relaxed italic">
                  VisionCarePlus is a preliminary screening and tele-consultation platform. It DOES NOT provide medical diagnoses and is NOT a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or qualified health provider with any questions you have regarding a medical condition.
                 </p>
              </div>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-[#D4AF37]">2. Acceptance of Terms</h2>
              <p className="text-zinc-300 leading-relaxed">
                By accessing and using VisionCarePlus, you accept and agree to be bound by the terms and provision of this agreement. Furthermore, when using these platform services, you shall be subject to any posted guidelines or rules applicable to such services.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-[#D4AF37]">3. User Responsibilities</h2>
              <p className="text-zinc-300 leading-relaxed">
                As a user, you agree to provide accurate and truthful information regarding your symptoms and personal details. You agree not to use the platform for any illegal or unauthorized purpose and to comply with all laws regarding online conduct and acceptable content.
              </p>
            </section>

             <section className="space-y-4">
              <h2 className="text-2xl font-bold text-[#D4AF37]">4. Tele-Consultation Services</h2>
              <p className="text-zinc-300 leading-relaxed">
                Consultations obtained via our platform are preliminary and do not replace physical eye examinations. Hardware and network malfunctions may occur; VisionCarePlus is not liable for delayed communications in the case of emergencies. <strong className="text-white">In the event of a medical emergency, visit your nearest hospital immediately.</strong>
              </p>
            </section>
            
            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-[#D4AF37]">5. Intellectual Property</h2>
              <p className="text-zinc-300 leading-relaxed">
                The platform and its original content, features, and functionality are owned by VisionCarePlus and the Leo Club of SLIIT IT Department, and are protected by international copyright, trademark, and other intellectual property or proprietary rights laws.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-2xl font-bold text-[#D4AF37]">6. Modifications to Service</h2>
              <p className="text-zinc-300 leading-relaxed">
                We reserve the right at any time to modify or discontinue the Service (or any part or content thereof) without notice at any time. We shall not be liable to you or to any third-party for any modification, suspension or discontinuance of the Service.
              </p>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default TermsOfService;
